import createLinkModel from '../selectors/createLinkModel';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { addSharePointLink, removeSharingLink } from '../actions/publicActions';

mutator(addSharePointLink, actionMessage => {
    const store = getStore();
    const linkModel: SharingLinkInfo = createLinkModel(
        actionMessage.linkId,
        actionMessage.url,
        actionMessage.response
    );

    store.sharingLinks.set(actionMessage.linkId, linkModel);
});

mutator(removeSharingLink, actionMessage => {
    const store = getStore();
    store.sharingLinks.delete(actionMessage.linkId);
});
